import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Navbar } from '../landing/components/Navbar';
import { Footer } from '../landing/components/Footer';

const PrivacidadPage = () => {
    const navigate = useNavigate();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    // Cuando se hace clic en una opción del Navbar o Footer, nos lleva de vuelta a la página principal
    const changeView = (newView) => {
        navigate('/', { state: { view: newView } });
        window.scrollTo(0, 0);
    };

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col font-sans text-gray-800">
            <Navbar 
                scrolled={true} 
                view="privacidad" 
                changeView={changeView} 
                mobileMenuOpen={mobileMenuOpen} 
                setMobileMenuOpen={setMobileMenuOpen} 
            />

            {/* Espaciado superior para el Navbar fixed */}
            <div className="pt-24 pb-8 flex-grow">
                <main className="max-w-4xl mx-auto p-6 md:p-12 w-full">
                    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 md:p-12 prose prose-blue max-w-none">
                        <h1 className="text-3xl font-bold text-gray-900 mb-2">Política de Privacidad</h1>
                        <p className="text-gray-500 mb-8 font-medium">Última actualización: 25 de junio de 2026</p>

                        <div className="space-y-8 text-gray-700">
                            <section>
                                <h2 className="text-xl font-bold text-gray-900 mb-4 border-b pb-2">1. INFORMACIÓN QUE RECOPILAMOS</h2>
                                <p className="mb-3">AquaGestión recopila la siguiente información personal de los usuarios autorizados por las juntas administradoras de agua:</p>
                                <ul className="list-disc pl-6 space-y-2">
                                    <li>Nombre completo</li>
                                    <li>Número de cédula de identidad</li>
                                    <li>Dirección domiciliaria</li>
                                    <li>Número de teléfono</li>
                                    <li>Correo electrónico</li>
                                    <li>Fotografía de perfil (opcional)</li>
                                    <li>Datos de consumo de agua asociados a medidores</li>
                                </ul>
                            </section>

                            <section>
                                <h2 className="text-xl font-bold text-gray-900 mb-4 border-b pb-2">2. USO DE LA INFORMACIÓN</h2>
                                <p className="mb-3">La información recopilada se utiliza exclusivamente para:</p>
                                <ul className="list-disc pl-6 space-y-2">
                                    <li>Autenticación y acceso seguro al sistema</li>
                                    <li>Registro y control de lecturas de consumo de agua potable</li>
                                    <li>Gestión administrativa del servicio de agua potable</li>
                                    <li>Generación de reportes de consumo</li>
                                </ul>
                            </section>

                            <section>
                                <h2 className="text-xl font-bold text-gray-900 mb-4 border-b pb-2">3. ALMACENAMIENTO Y SEGURIDAD</h2>
                                <ul className="list-disc pl-6 space-y-2">
                                    <li>Los datos se almacenan en servidores seguros con encriptación</li>
                                    <li>Las contraseñas se almacenan utilizando hash criptográfico avanzado</li>
                                    <li>La comunicación se realiza mediante protocolo seguro HTTPS</li>
                                    <li>Los datos locales en la aplicación móvil están protegidos por la base de datos del sistema operativo</li>
                                </ul>
                            </section>

                            <section>
                                <h2 className="text-xl font-bold text-gray-900 mb-4 border-b pb-2">4. COMPARTICIÓN DE DATOS</h2>
                                <p className="mb-3">No vendemos, comercializamos ni transferimos datos personales a terceros. La información solo es accesible por:</p>
                                <ul className="list-disc pl-6 space-y-2">
                                    <li>El propio usuario (lecturador, administrador)</li>
                                    <li>Los administradores autorizados de la junta de agua correspondiente</li>
                                </ul>
                            </section>

                            <section>
                                <h2 className="text-xl font-bold text-gray-900 mb-4 border-b pb-2">5. DERECHOS DEL USUARIO</h2>
                                <p className="mb-3">Los usuarios tienen derecho a:</p>
                                <ul className="list-disc pl-6 space-y-2">
                                    <li>Acceder a sus datos personales en cualquier momento</li>
                                    <li>Solicitar la corrección de datos incorrectos o desactualizados</li>
                                    <li>Solicitar la eliminación de su cuenta y datos asociados</li>
                                </ul>
                                <p className="mt-4">Para ejercer estos derechos, el usuario debe contactar al administrador de su junta de agua o escribir a los canales oficiales detallados abajo.</p>
                            </section>

                            <section>
                                <h2 className="text-xl font-bold text-gray-900 mb-4 border-b pb-2">6. CONTACTO</h2>
                                <p>Para consultas técnicas, legales o dudas sobre esta política de privacidad, puede comunicarse a:</p>
                                <div className="bg-blue-50/50 p-6 rounded-xl mt-4 border border-blue-100/50">
                                    <p className="mb-2"><strong>Email:</strong> info@polidevs.com</p>
                                    <p><strong>Sitio web:</strong> <a href="https://polidevs.com" className="text-blue-600 hover:underline">https://polidevs.com</a></p>
                                </div>
                            </section>
                        </div>
                    </div>
                </main>
            </div>

            <Footer changeView={changeView} />
        </div>
    );
};

export default PrivacidadPage;
